function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  stroke: "#000",
  strokeWidth: "2",
  cx: "20",
  cy: "20",
  r: "17"
}), React.createElement("circle", {
  fill: "#000",
  cx: "20",
  cy: "20",
  r: "7.5"
}))));